import React from 'react';
import '../css/Home.css';
import { motion } from 'framer-motion';
import cTOne from '../../images/kpmg.png';
import cTTwo from '../../images/deloite.png';
import cTThree from '../../images/berkshire.png';
import cTFour from '../../images/Google.png';
import cTFive from '../../images/pwc.jpg';
import cTSix from '../../images/microsoft.png';
import cTSeven from '../../images/JPMorgan.png';
import cTEight from '../../images/Goldman.jpg';
import cTNine from '../../images/spg-logo.jpg';
import cTTen from '../../images/sociazy-logo.jpg';
import cTEleven from '../../images/tobor-logo.jpg';
import cTTwelve from '../../images/nervana-logo.jpg';
import cTthirteen from '../../images/p-edits.jpg'; 
import cTFourteen from '../../images/bluebox3.png';
import cTFifteen from '../../images/S51logo1.png';

const OurPartner = () => {

    return (
        <>
            {/* <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading-first">
                        <span className="highlight-orange">Trusted By 350+</span> Global Enterprises to solve their biggest <span className="highlight-orange">software challenges</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-4">
                    <a
                        href="/contact-us"
                        className="btn custom-orange-btn py-3 px-4 fw-bold"
                    >
                        Get in Touch With Us
                    </a>
                </div>
            </motion.section> */}
            <section className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">Trusted By 350+</span> Global Enterprises to solve their biggest <span className="highlight-orange">software challenges</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-4">
                    <a
                        href="/contact-us"
                        className="btn custom-orange-btn py-3 px-4 fw-bold"
                    >
                        Get in Touch With Us
                    </a>
                </div>
                <motion.div
                    className="row justify-content-center align-items-center"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    {[
                        cTOne, cTTwo, cTThree, cTFour,
                        cTFive, cTSix, cTSeven, cTEight,
                        cTNine, cTTen, cTEleven, cTTwelve,cTthirteen, cTFourteen, cTFifteen // <-- added two new logos
                    ].map((imgSrc, idx) => (
                        <motion.div
                            className="col-6 col-md-2 mb-4 text-center" // 5 logos per row on desktop
                            key={idx}
                            whileHover={{ scale: 1.3 }}
                            transition={{ type: 'spring', stiffness: 300 }}
                        >
                            <img
                                src={imgSrc}
                                alt={`Client ${idx + 1}`}
                                className="img-fluid p-2"
                                style={{
                                    maxHeight:
                                        idx === 1 ? '60px' :
                                            idx === 6 ? '150px' :
                                                '120px',
                                    width: idx === 6 ? '110%' : 'auto',
                                    objectFit: 'contain',
                                    display: 'inline-block'
                                }}
                            />
                        </motion.div>
                    ))}
                </motion.div>

            </section></>
    );
};

export default OurPartner;
